import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { MODIFY_CUSTOMER } from '../../../apollo';
import { customerSlice, StoreState } from '../../../redux';
import { CheckoutCustomerInput } from '../../../../interfaces';

type UpdateCustomerEffectReturn = {
  updateCustomer: (customer: CheckoutCustomerInput) => void;
  loading: boolean;
  success: boolean;
  error: string | undefined;
};

export const useUpdateCustomerEffect = (
  callback?: (data?: any) => void
): UpdateCustomerEffectReturn => {
  const dispatch = useDispatch();

  const customer = useSelector(
    (state: StoreState) => state.customers.customer.customer
  );

  const id = customer?.id;

  const [success, setSuccess] = useState(false);

  const [doUpdateCustomer, { loading, error }] = useMutation(MODIFY_CUSTOMER, {
    onCompleted: (data) => {
      setSuccess(true);
      dispatch(customerSlice.actions.update(data.modifyCustomer));

      if (callback) {
        callback(data.modifyCustomer);
      }
    },
  });

  const updateCustomer = (data: CheckoutCustomerInput): void => {
    const variables = { data, id };

    doUpdateCustomer({ variables }).then();
  };

  return { updateCustomer, loading, success, error: error?.message };
};
